import ShareholderBenefitStore from '../ShareholderBenefitStore';

/**
 * @module ShareholderBenefits/Ranking/ShareholderBenefitRankingStore
 */
const ShareholderBenefitRankingStore = ShareholderBenefitStore;

export default ShareholderBenefitRankingStore;
